import { AzureOfferPlan } from '../../../../modules/privateOffer/reducer'
import { useStyles as usePricingStyles } from '../Sections.styles'
import {
  DetailInfo,
  DetailRow,
} from '../../../../common/components/DetailRow/DetailRow'
import { useStyles } from './PlanBillingTerms.styles'
import { calculateBuyerPrice } from '@labrav/common'
import { getPaymentOptionDisplayValue } from '../../../MicrosoftViewPricing/getPaymentOptionDisplayValue'
import { DisplayValueData } from '../../../PrivateOfferFormV2/AzureOffer/Plan/PlanRow/MeteringDimensions/MeteringDimensions'

interface PlanContractDetailsProps {
  plan: AzureOfferPlan
  isISV: boolean
  isPricePerUser: boolean
}

export const PlanContractDetails = ({
  plan,
  isISV = false,
  isPricePerUser = false,
}: PlanContractDetailsProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()

  const isFlexiblePayment =
    plan.pricing?.recurrentPrice?.prices[0]?.installments &&
    plan.pricing?.recurrentPrice?.prices[0]?.installments?.schedule?.length

  const tcvValue = isFlexiblePayment
    ? plan.pricing?.recurrentPrice?.prices[0]?.installments?.tcv
    : plan.pricing?.recurrentPrice?.prices[0]?.pricePerPaymentInUsd

  const markupPercentage = plan.markupPercentage

  const buyerPrice = calculateBuyerPrice({
    wholesalePrice: (tcvValue as number) || 0,
    percentage: markupPercentage || 0,
  })

  const getContractDuration = () => {
    const prices = plan.pricing?.recurrentPrice?.prices || []
    if (prices.length > 0) {
      const firstPrice = prices[0]
      if (firstPrice?.billingTerm?.value && firstPrice?.billingTerm?.type) {
        return `${firstPrice.billingTerm.value} ${firstPrice.billingTerm.type}`
      }
    }
    return 'Not specified'
  }
  const billingTerm = plan?.pricing.recurrentPrice?.prices[0]?.billingTerm
  const paymentOption = plan?.pricing?.recurrentPrice?.prices[0]?.paymentOption

  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Contract details</div>
      <DetailRow
        borderBottom
        className={classes.billingTermsRow}
        props={{ spacing: 4 }}
      >
        <>
          <DetailInfo
            title="Contract duration"
            value={getContractDuration()}
            keyName="contractDuration"
            gridSize={4}
          />

          {isISV && (
            <DetailInfo
              title="Payment terms"
              value={getPaymentOptionDisplayValue(billingTerm, paymentOption)}
              keyName="paymentTerms"
              gridSize={4}
              align="left"
            />
          )}
          <DetailInfo
            title={isPricePerUser ? 'Price per user(ISV)' : 'Price to ISV'}
            value={
              <DisplayValueData
                isPrice
                id="tcvValue"
                value={tcvValue as number}
                precision={5}
              />
            }
            keyName="priceToISV"
            gridSize={4}
            align={isISV ? 'end' : 'left'}
          />
          {!isISV && (
            <DetailInfo
              title={
                isPricePerUser ? 'Price per user(Buyer)' : 'Price from buyer'
              }
              value={
                <DisplayValueData
                  isPrice
                  id="buyerPrice"
                  value={buyerPrice as number}
                  precision={5}
                />
              }
              keyName="priceFromBuyer"
              gridSize={4}
              align="end"
            />
          )}
        </>
      </DetailRow>
    </div>
  )
}
